import { Button } from "./atoms";

interface SupportFormProps {
    onBack: () => void;
    onCancel: () => void;
    onNext: () => void;
}

/**
 * 応援設定フォームコンポーネント（Coming Soon）
 */
const SupportForm = ({ onBack, onCancel, onNext }: SupportFormProps) => {
    return (
        <div className="flex-1 flex bg-white rounded-lg overflow-hidden">
            {/* メインコンテンツ */}
            <div className="flex-1 flex flex-col">
                <div className="flex-1 relative flex items-center justify-center bg-black/40">
                    <span className="text-white text-3xl font-bold tracking-widest">Coming Soon</span>
                </div>

                {/* フッターボタン */}
                <div className="flex justify-end gap-4 px-6 py-4">
                    <Button variant="primary" size="md" onClick={onBack} className="px-8">
                        2.契約情報（個人）の設定に戻る
                    </Button>
                    <Button variant="outline" size="md" onClick={onCancel} className="px-8">
                        キャンセル
                    </Button>
                    <Button variant="primary" size="md" onClick={onNext} className="px-8">
                        4.タグの設定に進む
                    </Button>
                </div>
            </div>

            {/* 区切り線（右端） */}
            <div className="w-px bg-gray-200 my-4" />
        </div>
    );
};

export default SupportForm;
